import type {
  ExtranetTripCancellationReason,
  ExtranetTripOutput,
  ExtranetTripStatus,
} from '../../types/extranet-api.types';

/**
 * Helpers d'accès ExtranetTripOutput → vue front "ride".
 *
 * Maintenant que le back livre un shape dédié extranet (Yohan 2026-06-17),
 * la plupart des helpers se réduisent à des accès directs aux champs.
 * On garde la couche pour 2 raisons :
 *   1. Compat des composants qui les appellent déjà (Pas de bouger les call sites).
 *   2. Le `formatAmount` qui convertit les centimes (le back livre en centimes).
 */

export const getRideStatus = (trip: ExtranetTripOutput): ExtranetTripStatus => trip.status;

export const getCancellationReason = (trip: ExtranetTripOutput): ExtranetTripCancellationReason | null =>
  trip.cancellationReason;

export const getExternalRef = (trip: ExtranetTripOutput): string => trip.externalRef ?? '';

export const getContractRef = (trip: ExtranetTripOutput): string => trip.contractRef ?? '';

export const getCity = (trip: ExtranetTripOutput): string => trip.city ?? '';

export const getPickupAtISO = (trip: ExtranetTripOutput): string => trip.pickupAt;

/** Convertit les centimes back → euros front (1 décimale d'arrondi). */
export const getAmountEuros = (trip: ExtranetTripOutput): number => trip.amount / 100;
